import styled from "styled-components";

export const PrmModeWrapper = styled.div`
    display: grid;
    height: 100%;
    grid-template-rows: minmax(10%, min-content) minmax(10%, min-content) 1fr min-content min-content min-content;
`;
